import { useLocation, useNavigate } from "react-router-dom";
import * as S from "./NavItem.style";
import { useRecoilValue } from "recoil";
import { userInfoSelector } from "@/recoil/userInfo";

interface NavItemProps {
  data?: any;
  setLearningPwModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavItem = ({ data, setLearningPwModal }: NavItemProps) => {
  const userInfo = useRecoilValue(userInfoSelector);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (data: any) => {
    // 프로필 아이디가 필요한 페이지의 경우
    if (data.isProfileId) {
      // 프로필 아이디가 필요한데 flutter로 넘어가는 경우
      if (data.app) {
        if (!userInfo?.grow_learning_password) {
          // 부모가 설정한 그로우러닝 학습 비밀번호가 없는 경우
          setLearningPwModal!(true);
          return;
        }
        // 부모가 설정한 그로우러닝 학습 비밀번호가 있는 경우
        navigate("/auth/profile/select/learning");
        return;
      }
      // flutter로 넘어가진 않으나, 프로필 아이디가 필요한 페이지의 경우
      navigate("/auth/profile/select", {
        state: { pageIndex: 0, navigate: data.path },
      });
      return;
    }

    navigate(data.path);
  };

  return (
    <S.NavItem>
      <S.NavLink
        // href="/home"
        onClick={
          data.isUse
            ? () => {
                handleNavigation(data);
              }
            : undefined
        }
        $active={pathname.includes(data.path) ? true : false}
      >
        {pathname.includes(data.path) ? data.iconActive : data.icon}
        {data.menuTitle}
      </S.NavLink>
    </S.NavItem>
  );
};
